module.exports = __webpack_public_path__ + "img/breakfast.aff74d68.svg";